export default {
  listOrganizations: [],
}